import React from "react";
import { Cloud, Clouds, GradientTexture } from "@react-three/drei";
import { SPHERE_RADIUS } from "../LevelMenuIslands";
import * as THREE from "three";

export default function MenuSky() {
  const colorTop = "#FF7E88"; 
  const colorBottom = "#FF7E88"; 

  const groupRef = React.useRef<THREE.Group>(null);
  
  // const { camera } = useThree();
  // useFrame(() => {
  //   if (groupRef.current) {
  //     groupRef.current.position.copy(camera.position);
  //     groupRef.current.quaternion.copy(camera.quaternion);
  //   }
  // });

  return (
    <>
      <group ref={groupRef}>
        <mesh position={[0, 0, -800]}>
          <planeGeometry args={[2000, 1500]} />w
          <meshBasicMaterial >
            <GradientTexture
              stops={[0, 0.5, 1]} 
              colors={[colorTop, colorBottom]} 
              size={1500} 
            />
          </meshBasicMaterial>
        </mesh>
        
        {/* <group position={[0, 80, -400]}>
            <Clouds material={THREE.MeshStandardMaterial}>
            <Cloud 
                scale={0.6} 
                segments={40} 
                bounds={[700, 100, 100]}
                volume={120} 
                color="#fff" 
                opacity={1} 
                speed={0.05} 
                seed={10}
            />
            <Cloud 
                seed={2} 
                scale={0.5} 
                volume={60} 
                color="#fff"
                fade={100} 
                bounds={[700, 150, 50]}
                position={[0, 50, -50]}
                opacity={0.9}
            />
            </Clouds>
        </group> */}

        <mesh position={[200, 100, -500]}>
          <circleGeometry args={[40, 40]} />
          <meshBasicMaterial color="#fff4b0"/>
        </mesh>
      </group>
      
      <ambientLight intensity={0.2} />
      <directionalLight position={[SPHERE_RADIUS * 4, SPHERE_RADIUS * 4, SPHERE_RADIUS * 10]} intensity={2.8} color="#fff" castShadow />
    </>
  );
}
